import React, { useContext } from 'react';

import { H5 } from 'components/typography';
import { useTranslation } from 'react-i18next';

import { ContentRendererContext } from 'lane-shared/contexts';

import { CustomFieldRenderer } from 'domains/visitorManagement/feature/components/CustomFieldsSection/CustomFieldRenderer';
import type { CustomFieldRendererField } from 'domains/visitorManagement/feature/components/CustomFieldsSection/customField.types';

import styles from './VisitorInviteCustomFieldValues.scss';

export type VisitorInviteCustomFieldValuesProps = {
  isPreview?: boolean;
  valueByConfigId: Record<string, string | string[]>;
  onFieldValueChange: (customFieldConfigId: string, fieldKey: string, value: string | string[]) => void;
  fieldsToShow: CustomFieldRendererField[];
  errors?: Record<string, string>;
};

export function VisitorInviteCustomFieldValues({
  isPreview = false,
  valueByConfigId,
  onFieldValueChange,
  fieldsToShow,
  errors = {},
}: VisitorInviteCustomFieldValuesProps) {
  const { t } = useTranslation();
  const { editMode } = useContext(ContentRendererContext);

  if (fieldsToShow.length === 0) {
    return null;
  }

  return (
    <div
      className={styles.visitorInviteCustomFieldValues}
      data-test="visitorInviteCustomFieldValues"
    >
      {editMode && (
        <H5 className={styles.heading}>
          {t(
            'web.admin.content.features.visitor.management.general.customFields.title'
          )}
        </H5>
      )}
      {fieldsToShow.map(field => (
        <CustomFieldRenderer
          key={field.id}
          field={field}
          disabled={isPreview}
          value={valueByConfigId[field.id]}
          onChange={next => onFieldValueChange(field.id, field.fieldKey, next)}
          error={errors[field.fieldKey]}
          isRequired
        />
      ))}
    </div>
  );
}
